import React from "react";
import { Link, useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/paysuccess.css";

const PaySuccess = () => {
  const location = useLocation();
  const suppliedOrderNumber = location.state?.orderNumber;
  const orderNumber = suppliedOrderNumber
    ? String(suppliedOrderNumber).replace(/^#/, "")
    : null;

  return (
    <main className="success-page" aria-labelledby="success-title">
      <section className="success-page__card">
        <div className="success-page__mark" aria-hidden="true">
          ✓
        </div>
        <p className="success-page__eyebrow">Order received</p>
        <h1 id="success-title">Thank you.</h1>
        <p className="success-page__lead">
          Your order with {siteConfig.brandName} is now being reviewed. We will send
          confirmation and tracking details to the email supplied at checkout.
        </p>

        <dl className="success-page__details">
          <div>
            <dt>Order reference</dt>
            <dd>{orderNumber ? `#${orderNumber}` : "Included in your confirmation email"}</dd>
          </div>
          <div>
            <dt>Status</dt>
            <dd>Preparing for dispatch</dd>
          </div>
        </dl>

        <div className="success-page__actions">
          <Link className="success-page__primary" to="/shop">
            Continue shopping
          </Link>
          <Link className="success-page__secondary" to="/contact">
            Contact customer care
          </Link>
        </div>
      </section>
    </main>
  );
};

export default PaySuccess;
